import { InfoCircleOutlined } from '@ant-design/icons';
import { partner } from '@mep/pae-commons';
import { Tag, Tooltip } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { PARTNER_STATUS_APPEARANCE } from '@/modules/proposalRequest/components/PartnerStatus/partner.status';

const { PARTNERSHIP_REQUEST_ENUM, PARTNERSHIP_REQUEST } = partner;

const PartnerStatus = ({ status, full, help, className, icon, ...props }) => {
  const { t } = useTranslation('proposalRequest');
  
  if (!PARTNER_STATUS_APPEARANCE[status])
    return (
      <Tag key={status} className={classNames({ 'w-full': full }, className, 'w-16 text-center')}>
        -
      </Tag>);
  
  return (
    <Tag
      color={PARTNER_STATUS_APPEARANCE[status].color} key={status}
      className={classNames('table-tag-item', { 'w-full': full }, 'flex justify-center', className)} {...props}>
      <div className={'flex items-center'}>
        {icon}
        <span className={'flex-grow '}>{t(`proposalDetails.partnersAndWorkers.partners.status.${status}`)}</span>
        {help &&
        <Tooltip title={t(`proposalDetails.partnersAndWorkers.partners.status.${status}_HELP`)} className="ml-2">
          <InfoCircleOutlined/>
        </Tooltip>
        }
      </div>
    </Tag>
  );
};

PartnerStatus.propTypes = {
  className: PropTypes.string,
  help: PropTypes.bool,
  full: PropTypes.bool,
  status: PropTypes.oneOf(PARTNERSHIP_REQUEST_ENUM),
  icon: PropTypes.any,
};

PartnerStatus.defaultProps = {
  status: PARTNERSHIP_REQUEST.PENDING
};

export default memo(PartnerStatus);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Status component in a table cell
 * @param {String} status this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} user this is the row instance
 * */
export const renderPartnerStatus = (status, user) => {
  return (
    <PartnerStatus status={status} user={user}/>
  );
};
